import { array, object, string } from 'yup';
import formsBaseActionProductValidation, {
  fileValidationSchema,
} from './base-action-product';

const testimonyValidation = object().shape({
  firstName: string().required('validations.testimony.first_name.required'),
  lastName: string().optional().nullable(),
  role: string().optional().nullable(),
  trainingYear: string().optional().nullable(),
  content: string().required('validations.testimony.content.required'),
  video: string().optional().nullable(),
  image: fileValidationSchema
    .default(undefined)
    .required('validations.testimony.image.required'),
});

const formsProductValidation = object().shape({
  ...formsBaseActionProductValidation,
  testimonies: array().of(testimonyValidation),
});

export default formsProductValidation;
